<template>
  <div class="app-container">
    <!-- <transition name="el-zoom-in-top">
      <div class="filter-container">
        <el-card class="custom-card" shadow="never">
          <el-row :gutter="10">
            <el-col :lg="2">
              场地名称：<br>
              <el-input
                :placeholder="$t('table.fieldName')"
                v-model="listQuery.fieldName"
                class="filter-item"
              />
            </el-col>
            <el-col :lg="2">
              <br>
              <el-button
                v-waves
                round
                class="filter-item"
                type="primary"
                icon="el-icon-search"
                @click="handleFilter"
              >{{ $t('table.search') }}</el-button>
            </el-col>
          </el-row>
        </el-card>

      </div>
    </transition> -->
    <transition name="el-zoom-in-top">
      <div class="filter-container">
        <el-table
          v-loading="listLoading"
          :key="list.id"
          :data="list"
          fit
          stripe
          highlight-current-row
          style="width: 100%;"
        >
          <el-table-column :label="$t('table.id')" align="center" width="50px">
            <template slot-scope="scope">
              <span>{{ (scope.$index + 1) + ((listQuery.pageIndex - 1) * listQuery.pageSize) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="手机号" align="center">
            <template slot-scope="{row}">
              {{ row.mobile }}
            </template>
          </el-table-column>
          <el-table-column label="类型" align="center">
            <template slot-scope="{row}">
              {{ row.type ==0?'建议':'投诉' }}
            </template>
          </el-table-column>
          <el-table-column label="内容" align="center" show-overflow-tooltip="">
            <template slot-scope="{row}">
              {{ row.content }}
            </template>
          </el-table-column>
          <el-table-column label="图片" align="center">
            <template slot-scope="{row}">
              <template v-if="row.imgs.length">
                <el-image
                  :src="url_+row.imgs[0]"
                  :preview-src-list="row.imgs.map(item => url_+item)"
                  style="width: 30px;height: 30px;"
                />
              </template>

            </template>
          </el-table-column>
        </el-table>
        <el-card class="custom-card" shadow="never">
          <el-pagination
            v-show="total>0"
            :current-page="listQuery.pageIndex"
            :page-sizes="[10,20,50,100]"
            :page-size="listQuery.pageSize"
            :total="total"
            layout="total, prev, pager, next"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </el-card>
      </div>
    </transition>

  </div>
</template>
<script>
import { fetchList } from './api'
import { qryRoleInfo } from '@/api/baseModule'
// import { parseTime } from '@/utils'
import waves from '@/directive/waves' // 水波纹指令
export default {
  name: 'Ordermanage',
  directives: {
    waves
  },
  filters: {
  },
  data() {
    return {
      refundVisible: false,
      splitOrderData: [],
      orderStates: [
        {
          value: null,
          label: '全部'
        },
        {
          value: 'D',
          label: '使用中'
        },
        {
          value: 'S',
          label: '订单结束'
        }

      ],
      listQuery: {
        pageIndex: 1,
        pageSize: 10
      },
      listLoading: true,
      list: [],
      permition: 0,
      total: null,
      TotalMoney: 0,
      VirtualMoney: 0,
      bookType: 'xlsx',
      bookTypeList: ['xlsx', 'csv', 'txt'],
      downloadLoading: false,
      roleId: null,
      url_: process.env.BASE_API
    }
  },
  watch: {
    listQuery: {
      handler(value) {
        console.log(value)
        for (const key in value) {
          if (!value[key]) {
            value[key] = null
          }
        }
      },
      deep: true
    }
  },
  created() {
    this.roleId = this.$store.getters.roles.RoleId
    if (this.$store.state.roleInfo) {
      this.$store.state.roleInfo.LsList[0].RolePrograms.forEach(item => {
        if (this.$route.path === item.ProgramInfo.PgUrl) {
          this.permition = item.Permition
          this.getList()
        }
      })
      // this.$store.state.roleInfo.LsList[0].RolePrograms.forEach(item => {
      //   if (this.$route.path === item.ProgramInfo.PgUrl) {
      //     this.permition = item.Permition
      //     this.qryOrder()
      //   }
      // })
    } else {
      qryRoleInfo({
        rId: this.$store.getters.roles.RoleId
      }).then(response => {
        this.$store.state.roleInfo = response
        response.LsList[0].RolePrograms.forEach(item => {
          if (this.$route.path === item.ProgramInfo.PgUrl) {
            this.permition = item.Permition
            this.getList()
          }
        })
      })
    }
  },
  methods: {
    // 获取场地列表
    getList() {
      fetchList(this.listQuery).then(res => {
        console.log(res)
        this.list = res.LsList
        this.total = res.TotalRows
        this.listLoading = false
      })
    },

    handleSizeChange(e) {
      this.listQuery.pageSize = e
      this.getList()
    },
    handleCurrentChange(e) {
      this.listQuery.pageIndex = e
      this.getList()
    },
    handleFilter() {
      this.listQuery.pageIndex = 1
      // this.listQuery.name = this.listQuery.key
      this.getList()
    }
  }
}
</script>
<style lang="less" scoped>
.custom-width{
  width: 100%;
}
</style>
